module.exports = require("@react-native-community/netinfo");